// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var menuBlock = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.justifyContent("flexStart"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
            BsCssJs$PrezzeeRibbon.flexGrow(1),
            BsCssJs$PrezzeeRibbon.display("flex")
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(16))])
    ]);

var Styles = {
  menuBlock: menuBlock
};

function TopNavigationBar__Navlinks(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    menuBlock,
                    className$1
                  ])
            });
}

var make = TopNavigationBar__Navlinks;

export {
  Styles ,
  make ,
}
/* menuBlock Not a pure module */
